import {
  TemperatureEntity,
} from './temperatureEntity';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';
import { Temperature } from './valueObjects/temperature';

import type {
  TemperaturePropsPub,
  TemperaturePropsPvt,
} from './temperatureEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { TemperatureJsonPub, TemperatureJsonPvt } from '@/types/domain/temperature/entities/temperatureEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class TemperatureFactory extends FactoryPub<
  TemperatureEntity,
  TemperaturePropsPvt,
  TemperatureJsonPvt,
  TemperaturePropsPub,
  TemperatureJsonPub
> {
  comparePub = (
    a: EntityDataPubType<TemperatureJsonPvt, TemperatureJsonPub>,
    b: EntityDataPubType<TemperatureJsonPvt, TemperatureJsonPub>,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: TemperaturePropsPvt,
    propsPub: EntityPubNotNullType<TemperaturePropsPub>,
  ): TemperatureEntity {
    return new TemperatureEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<TemperatureJsonPvt, TemperatureJsonPub>,
  ): TemperatureEntity {
    return this.create({
      measureDateTime: MeasureDateTime.create(new Date(props.data.measureDateTime)),
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
      temperature: Temperature.create(props.data.temperature),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
